import { render } from "./AdminRouterLink.vue?vue&type=template&id=075e7826"
import script from "./AdminRouterLink.vue?vue&type=script&lang=js"
export * from "./AdminRouterLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__